import service from "@/services/proposals";
import { getBanner, createUpdateDetailDeals, dealsByVanity, generalDetailDeals, myDeals, updateDeal, createDeal, deleteDeal, createCheckout, startChatBrandmeTalent, requestRevisionChat, acceptContents, requestRevisionLinks, acceptLinks, dealsPrivate, getDealsPaid, getMessageChatDeal, searchProposals} from "@/services/proposals-refactored";

const handleResponse = (res, fallbackMessage = 'Ha ocurrido un error') => {
  if (res?.status >= 400) {
    const message = res?.data?.response?.message ?? res?.data?.message ?? fallbackMessage;
    throw new Error(message);
  }
  return res?.response ?? res;
};

export const proposalsRepository = {
  async getFavoriteProposals() {
    const res = await service.getFavoriteProposals();
    return res?.results ?? [];
  },
};

export const proposalsDealsRepository = {
  async getProposalsUser(data, vanity_name, current_page = 1, per_page = 5) {
    const res = await dealsByVanity(data, vanity_name, current_page, per_page);
    return res ?? [];
  },

  async getDetailsProposals(vanity_name) {
    const res = await generalDetailDeals(vanity_name);
    return res ?? {};
  },

  async createChatBrandmeTalent(data) {
    const res = await startChatBrandmeTalent(data);
    return handleResponse(res, 'Error al crear el chat');
  },

  async createCheckout(data, deal_uuid) {
    const res = await createCheckout(data, deal_uuid);
    return handleResponse(res, 'Error al crear el checkout');
  },

  async myDeals(data, current_page = 1, per_page = 5) {
    const res = await myDeals(data, current_page, per_page);
    return res ?? [];
  },

  async dealsPrivate(data, chat_uuid, current_page = 1, per_page = 5) {
    const res = await dealsPrivate(data, chat_uuid, current_page, per_page);
    return res ?? [];
  },

  async createUpdateDetailDeals(data) {
    const res = await createUpdateDetailDeals(data);
    return handleResponse(res, 'Error al crear o actualizar los detalles de la propuesta');
  }
}

export const crudDealsRepository = {
  async createDeal(data) {
    const res = await createDeal(data);
    return handleResponse(res, 'Error al crear el deal');
  },
  async updateDeal(deal_uuid, data) {
    const res = await updateDeal(deal_uuid, data);
    return handleResponse(res, 'Error al actualizar el deal');
  },
  async deleteDeal(deal_uuid) {
    const res = await deleteDeal(deal_uuid);
    return handleResponse(res, 'Error al eliminar el deal');
  },
}

export const chatsRepository = {
  async requestRevisionChat(chat_uuid, message) {
    const res = await requestRevisionChat(chat_uuid, message);
    return handleResponse(res, 'Error al solicitar revisión');
  },

  async acceptContents(chat_uuid) {
    const res = await acceptContents(chat_uuid);
    return handleResponse(res, 'Error al aceptar contenidos');
  },

  async requestRevisionLinks(chat_uuid, message) {
    const res = await requestRevisionLinks(chat_uuid, message);
    return handleResponse(res, 'Error al solicitar revisión de links');
  },

  async acceptLinks(chat_uuid) {
    const res = await acceptLinks(chat_uuid);
    return handleResponse(res, 'Error al aceptar links');
  },
  async getDealsPaid(chat_uuid) {
    const res = await getDealsPaid(chat_uuid);
    return handleResponse(res, 'Error al obtener los deals pagados');
  },
  async getMessageChatDeal(chat_deal_uuid) {
    const res = await getMessageChatDeal(chat_deal_uuid);
    return handleResponse(res, 'Error al obtener el mensaje del chat deal');
  },
}

export const searchProposalsRepository = {
  async searchProposals(query, perPage, currentPage) {
    const res = await searchProposals(query, currentPage, perPage);
    return res ?? { count: 0, results: [] };
  },

  async getCollaborationBanners(banner) {
    const res = await getBanner({ banner });
    return res?.results ?? [];
  },
}